__turbopack_context__.v({
  "cta-subtitle": "subscription-purchase-content-module-scss-module__B8KoLq__cta-subtitle",
  "description": "subscription-purchase-content-module-scss-module__B8KoLq__description",
  "includes-info-trigger": "subscription-purchase-content-module-scss-module__B8KoLq__includes-info-trigger",
  "learn-more-link": "subscription-purchase-content-module-scss-module__B8KoLq__learn-more-link",
  "learn-more-link-blended": "subscription-purchase-content-module-scss-module__B8KoLq__learn-more-link-blended",
  "learn-more-link-default": "subscription-purchase-content-module-scss-module__B8KoLq__learn-more-link-default",
  "personal-plan-value-prop": "subscription-purchase-content-module-scss-module__B8KoLq__personal-plan-value-prop",
  "subscription-cta": "subscription-purchase-content-module-scss-module__B8KoLq__subscription-cta",
  "subscription-cta-collapsible": "subscription-purchase-content-module-scss-module__B8KoLq__subscription-cta-collapsible",
  "title": "subscription-purchase-content-module-scss-module__B8KoLq__title",
  "title-row": "subscription-purchase-content-module-scss-module__B8KoLq__title-row",
  "value-prop-badge": "subscription-purchase-content-module-scss-module__B8KoLq__value-prop-badge",
  "value-prop-text": "subscription-purchase-content-module-scss-module__B8KoLq__value-prop-text",
});
